"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'devices';
exports.REGISTER_DEVICE = exports.namespace + "/REGISTER_DEVICE";
exports.DEACTIVATE_DEVICE = exports.namespace + "/DEACTIVATE_DEVICE";
exports.FETCH_DEVICES = exports.namespace + "/FETCH_DEVICES";
exports.UPDATE_DEVICE_NAME = exports.namespace + "/UPDATE_DEVICE_NAME";
exports.SET_PLAYBACK_DEVICE = exports.namespace + "/SET_PLAYBACK_DEVICE";
exports.SET_SERIAL_NUMBER = exports.namespace + "/SET_SERIAL_NUMBER";
exports.FETCH_DEVICE_SESSIONS = exports.namespace + "/FETCH_DEVICE_SESSIONS";
exports.SIGN_OUT_DEVICE = exports.namespace + "/SIGN_OUT_DEVICE";
exports.SIGN_OUT_ALL_DEVICES = exports.namespace + "/SIGN_OUT_ALL_DEVICES";
exports.RESET_SIGN_OUT_DEVICE = exports.namespace + "/RESET_SIGN_OUT_DEVICE";
//# sourceMappingURL=constants.js.map